import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoadingState from "../components/common/LoadingState";

export default function PublicRoute() {
  const { initializing, isAuthenticated } = useAuth();

  if (initializing) {
    return <LoadingState compact title="Loading session..." />;
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
